import { Modal } from "antd";
const { confirm } = Modal;

export { default } from "./Modal";
export { default as Modal } from "./Modal";
export { confirm };
